import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import {
  type AutomationsAnalyticsListStatus,
  type AutomationsAnalyticsPromptMode,
  withAutomationsCategory,
} from './automationsAnalytics';
import META from './useTrackAutomationsPageViewed.meta';

export type UseTrackAutomationsPageViewedParams =
  | {
      page: 'list';
      list_state: 'empty';
    }
  | {
      page: 'list';
      list_state: 'populated';
      automation_count: number;
    }
  | {
      page: 'create';
    }
  | {
      page: 'detail';
      automation_id: string;
      enabled: boolean;
      prompt_mode: AutomationsAnalyticsPromptMode;
      list_status: AutomationsAnalyticsListStatus;
    };

export const useTrackAutomationsPageViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationsPageViewed = useCallback(
    (params: UseTrackAutomationsPageViewedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationsPageViewed };
};
